<template>
  <div id="home">
    <Nav />
    <img class="puppy-logo" alt="Puppy Coin logo" src="./assets/logo.png">
    <Content msg="$PUPPY"/>
     <vue-particles
        color="#dedede"
        :particleOpacity="0.4"
        :particlesNumber="30"
        shapeType="circle"
        :particleSize="10"
        linesColor="#ff9b00"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="250"
        :moveSpeed="2"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      />
  </div>
</template>

<script>
import Nav from './components/Nav.vue'
import Content from './components/Content.vue'

export default {
  name: 'App',
  components: {
    Nav,
    Content,
  },
}
</script>

<style>
body {
  margin: 0;
  color: white;
  background: #262626;
  color: #b62525;
  background: #ffefef;
  font-weight: 500;
}

#home {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding: 24px;
  margin: 60px auto 0;
  scroll-behavior: smooth;
}

#particles-js canvas {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.puppy-logo {
  width: 100%;
  max-width: 170px;
  box-sizing: border-box;
  padding: 0 16px;
}

h1 {
  font-size: 48px;
}

h1, h3 {
  color: #f88a8d;
  color: #c82b30;
}

@media (min-width: 769px) {
  #home {
    margin-top: 0;
  }
  .puppy-logo {
    margin-top: 50px;
    margin-top: 80px;
  }
}
</style>
